export const SIGN_IN = 'signIn'
export const SIGN_OUT = 'signOut'
export const SET_USER_DATA = 'setUserData'

export const SET_VIEW_REPORT_AS = 'setViewReportAs'
